<template>
    <div class="columns is-centered">
        <div class="column is-4">
      <router-link to="/library" class="button is-primary is-fullwidth is-size-5" v-t="'open_library'"></router-link>
    </div></div>
</template>

<script>
export default {}
</script>

<style scoped>
.section{
    padding-top: 2rem;
    padding-bottom: 2rem;
}
</style>
